const aboutEntries = {
  image: '/assets/me.webp',
  title: "Hello! I'm Ellie 👋",
  description: `I am a UX designer tremendously curious about the intersection of Psychology 👁️‍🗨️, Design 📌, and Technology 🥽. I believe that the integration of these disciplines enables us to create products and experiences that are meaningful and beneficial to people.
  
  Here are a few facts about me:`,
  bullets: [
    {
      emoji: "🎨",
      text: "I love crafting! From embroidering to laser cutting to painting, I love working with my hands and gifting my creations to friends and family."
    },
    {
      emoji: "⛺",
      text: "One of my favorite things is to be outside and enjoy the sun! You can catch me biking, hiking, camping on weekends (add me on Strava)!"
    },
    {
      emoji: "🧦",
      text: "You will most likely catch me wearing something thrifted! Not only is it beneficial to the environment, it's so rewarding to find unique pieces. I also attempt to tailor them with my sewing machine from time to time."
    },
    {
      emoji: "🎓",
      text: "Growing up, I wanted to become a teacher so went to Carnegie Mellon to study Cognitive Science. Somewhere along the way, I found my way to design and doubled majored in Human Computer Interaction-- and now, here we are!"
    },
  ],
};

export default aboutEntries;
